!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/searchForm',['libs/ct_view','libs/ct_pers', 'libs/ct_store', 'hotelBackgroundSearch', 'hotels/searchFormSettings', 'widgets/ct_autocomplete', 'widgets/ct_datepicker', 'widgets/ct_roompaxwidget', 'widgets/warningValidator', 'hotels/hotelWarnValidate', 'widgets/validator', 'vendor/moment.min', 'hotels/hotelAutoCompleteResponse', 'widgets/chosen.jquery'], module)
		else
	//>>excludeEnd("requireTmpl");
context[name] = module(CT.View, CT.Pers, CT.Store, CT.hotelBackgroundSearch, CT.settings.searchForm)
}('searchForm', function(View, Pers, Store, hotelBackgroundSearch, searchFormSettings){

	var searchFormView = CT.cache.views.searchForm = View($.extend(searchFormSettings, { //TODO Please don't attach methods to validators. Common view properties cannot be used because of that - Parag
		$el : $('#SearchForm'),

		events : {
			'updateTabIndices' : 'updateTabIndices',
			'click #withinCity' : 'updateWgParams',
			'click #outsideCity' : 'updateWgParams',
			'focus #Tags' : 'shwRecentAutoComplete',
			'keydown #Tags' : 'shwRecentAutoComplete',
			'click #airBnb' : 'airBnbSearch',
			'click #recentAutoComplete':'updateRecentSearchForm',
			'change .selectRoom'  : 'updateTabIndices',
			'change .alterAdult'  : 'updateTabIndices',
			'change .alterChild'  : 'updateTabIndices',
			'change #travellersOnhome':'travellersOnChange',
			'change #FromDate,#ToDate,.selectRoom,.alterAdult,.alterChild,#travellersOnhome':"onDateOrTravellerInfoChange"
		},

		onDateOrTravellerInfoChange: function(){
			var isEnableHotelsBackgroundSearch = window.enableHotelsBackgroundSearch && (!window.isResultsPage || (window.isResultsPage && CT.cache[CT.settings.currentTab].isSRPLoaded));
			if(isEnableHotelsBackgroundSearch){
				hotelBackgroundSearch.getScData();
			}
		},
		subscriptions : {
			'searchForm.update' : 'renderSearchForm'
		},
		updateRecentSearchForm : function(e){
			var recentPers = new Pers(), 
			recentObjArr = recentPers.get('recent'), 
			clickedObjCity = $(e.target).parent().attr("data-city"),
			renderObj = _.filter(recentObjArr, function(obj) { return (obj.ct === clickedObjCity)}), mustacheData = [], rsObj = renderObj[renderObj.length-1],
			adultArr = [], childArr = [], chldLen=0, childAgeArr = [];
			
			rsObj['frmWhere'] = rsObj.ct, rsObj['chk_in'] = rsObj.cid == '' ? '' :rsObj.cid, rsObj['chk_out'] = rsObj.co == '' ? '' : rsObj.co,
			rsObj['from'] = rsObj.ct, rsObj['city'] = rsObj.ct, rsObj['state'] = rsObj.st, rsObj['country'] = rsObj.cy, rsObj.num_rooms = rsObj.nor,
			rsObj.sd = new Date().getTime();
			var categorySelected = 'City';

			if(rsObj.ar && rsObj.ar != 'undefined' && rsObj.ar != ''){
				rsObj.area = [rsObj.ar];
				rsObj.poi = '';
				categorySelected = 'Area';
			}
			else if(rsObj.poi && rsObj.poi != 'undefined'){
				categorySelected = 'POI';
				rsObj.area = '';
			} else {
				rsObj.poi = '';
				rsObj.area = '';
				categorySelected = 'City';
			}

			if(rsObj.hnm == 'undefined'){
				rsObj.hnm = '';
			}

			// filling adults data
			for(var k in rsObj.ad){
				if(k != "s")
					rsObj["adults"+k] = rsObj.ad[k];
			}
			rsObj.adults = rsObj.ad["s"];
			
			// filling children data
			for(var k in rsObj.cd){
				rsObj["children"+k] = rsObj.cd[k];
			}
			rsObj.childs = chldLen;

			// filling children ages data
			for(var k in rsObj.aoc){
				rsObj["ca"+k] = [];
				for(var i=0;i<rsObj.aoc[k].length;i++){
					rsObj["ca"+k].push(rsObj.aoc[k][i])
				}
			}
			rsObj.wgSearch = false;
			rsObj.cityName = rsObj.ct;
			mustacheData.push(rsObj);
			$("#recentAutoComplete").hide();
			CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Home_searchbar_selectItem", {
				"searchType": "RecentSearches",
				"searchedItem":"N/A",
				"lenSearchedItem":"N/A",
				"searchCategorySelected": categorySelected
			});
			CT.utils.trackers.eventData.categorySelected = categorySelected;
			CT.utils.trackers.eventData.searchType = "recent";
			this.renderSearchForm(null,mustacheData);
		},
		shwRecentAutoComplete: function(e){
			if (e.type === "keydown" && e.key !== "Enter" && e.key !== "Tab") {
				// Disable submit button while typing
				$("#SearchHotelsButton").attr('disabled','disabled');
			}
				if(e.type === "focusin"){
				var lengthAutosuggest = $("#recentAutoComplete").find('li[role="presentation"]').length;
				CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Home_searchbar_click", {
					"countAutosuggest": lengthAutosuggest,
					"shortlistedCount": CT.shortListHotels.total ? CT.shortListHotels.total : "N/A"
				});
				$("#recentAutoComplete").show();
			}else{
				$("#recentAutoComplete").hide();
			}
			var handler = function(event){
				if($(event.target).is(".ui-autocomplete-input, .ui-autocomplete-input *, .recentAutoComplete, .recentAutoComplete *")) return;
				$(document).off("click", handler);
				$("#recentAutoComplete").hide();
			}
			$(document).on("click", handler);
		},
		airBnbSearch : function (e){
			CT.subProd = "airBnb";
			$("#Tags").autocomplete({ url: CT.settings[CT.app].autoCompleteUrl});
			$("#Tags").show();
			if($("body").hasClass("home") == true){
				$('body').removeClass("weekend");
			}
			$(".roomWidget").find("select").removeAttr("disabled")
			var params = _.deserialize(this.$el.serialize());
			var adltCnt = 0;
			for(var i=1;i<=parseInt(params.num_rooms);i++){
				adltCnt += parseInt(params['adults'+i])
			}
			$(".roomWidget").hide();
			$(".roomWidget").find("select").attr("disabled","disabled")
			$(".airbnbRoomWidget").find("select").val(adltCnt)
			$(".airbnbRoomWidget").closest("nav").show();
			$(".airbnbRoomWidget").find("select").removeAttr("disabled")
			if(CT.utils.cookies.read('hotelTripType') != null && CT.utils.cookies.read('hotelTripType') != "airBnb"){
				$(".airbnbRoomWidget").closest("nav").addClass("highlightMe");
			}
			$("#searchFieldLabel").attr("for","where").find("strong").html(CT.messages.hotel.Where);
			$("#Tags").removeAttr("disabled");
			$(".chzn-select").hide();
			$(".chzn-select").next().hide();
			CT.utils.cookies.create("hotelTripType","airBnb",365);
			CT.utils.helperFunctions.trackGAEventWrapper("Hotels_TS",'H_AIRBNB_PROPERTIES',"",'100');
		},
		updateWgParams : function(e,data){
			var _userId = CT.utils.cookies.read('userid');
			CT.subProd = (e != undefined && e.target.id === "outsideCity")?"wg":(data === "outsideCity")?"wg":undefined;
			/*if(_userId && _userId.indexOf('cleartrip.com') >= 0){
				$("#Tags").autocomplete({ url: (CT.subProd === undefined)?CT.settings[CT.app].autoCompleteUrl:CT.settings[CT.app][CT.subProd].autoCompleteUrl});
			}else{
				$("#Tags").autocomplete({ url: (CT.subProd === undefined)?CT.settings[CT.app].autoCompleteUrlTmp:CT.settings[CT.app][CT.subProd].autoCompleteUrl});

			}*/
			$("#Tags").autocomplete({ url: (CT.subProd === undefined)?CT.settings[CT.app].autoCompleteUrl:CT.settings[CT.app][CT.subProd].autoCompleteUrl});
			$(".roomWidget").find("select").removeAttr("disabled")
			// $(".roomWidget").show()
			if(CT.utils.cookies.read('hotelTripType') != null && CT.utils.cookies.read('hotelTripType') == "airBnb"){
				$(".roomWidget").addClass("highlightMe");
			}
			$(".airbnbRoomWidget").closest("nav").hide();
			$(".airbnbRoomWidget").find("select").attr("disabled","disabled");
			var url = "";
			if(CT.subProd == "wg"){
				$("#Tags").hide();
				if($("body").hasClass("home") == true){
					$('body').addClass("weekend");
				}
				$("#searchFieldLabel").attr("for","from").find("strong").html(CT.messages.hotel.From);
				$("#Tags").attr("disabled","disabled");
				$(".chzn-select").next().show();
				$(".chzn-select").removeAttr("disabled");
				$(".chzn-select").chosen({width: "100%"});
				$(".chosen-search input").addClass("wgAutoComplete")
				$(".chosen-search input").attr({
					"data-trauncate" :"false",
					"data-idfield" : "DestCode",
					"data-responsemodifier" : "responseModifierHotel", 
					"autocorrect" : "off",
					"data-selectionHandler" : "hotelSelectionHandler",
					"data-autocomplete-ui" : "true" ,
					"data-supressKeyDown" : "true",
					"data-url" : "", 
					"data-close":"true"
				})
				$(".chosen-search input").autocomplete({url: CT.settings[CT.app][CT.subProd].autoCompleteUrl});
				$(".chzn-select").on('change', function(evt, params) {
					var optEle = $('.chzn-select').find('option[value="' + params.selected + '"]');
					$('.chzn-select #updatedCities').html("");
					$('.chzn-select #SelectedCities').html("");
					gatewayAutoSuggest(JSON.parse($(optEle).attr('data-ui')),"SelectedCities",true);
					hotelSelectionHandler($("#wgSelectChoosen"),JSON.parse($(optEle).attr('data-ui')));
				});
				CT.utils.helperFunctions.trackGAEventWrapper("Hotels_TS",'H_Weekend_Gateway_From',url,'100');
				CT.utils.cookies.create("hotelTripType","outsideCity",365);
				CT.utils.helperFunctions.inspectLetJsForHotels();

			}else{
				$("#Tags").show();
				if($("body").hasClass("home") == true){
					$('body').removeClass("weekend");
				}
				$("#searchFieldLabel").attr("for","where").find("strong").html(CT.messages.hotel.Where);
				$("#Tags").removeAttr("disabled");
				$(".chzn-select").hide();
				$(".chzn-select").next().hide();
				CT.utils.cookies.create("hotelTripType","withinCity",365);
				CT.utils.helperFunctions.trackGAEventWrapper("Hotels_TS",'H_Travelleng_To',url,'100');

			}
			
		},
		render : function(){
			/*if(CT.settings.showCollection && CT.settings.showCollection === true){
				CT.utils.createCollectionsUpSell("static", $(".searchForm").first().parent(), {page:'hotel_home_page'});
			}*/
			$('#Result').hide();
			$('#Home').show();
			$('#HomeLongForm').show();
			$(".city_seo_content").show();
			CT.widgets.placeholder.parseDomTree(this.$el);
			// ct_ct tracking call.
			CT.utils.trackers.page_count({n:"si", p:"h"});
			if(CT.app=="hotel" && CT.subProd!="wg"){
					var PageName ="";
			    if($('#Home.modifySearch').length > 0){
					 PageName= "SRP";
					 $('.shortlistLink').hide();
					 $('#HomeLongForm').hide();
					 $(".city_seo_content").hide();
			    }
			    else if($('.changeDatesForm').length > 0){
			    	PageName= "Details page"
			    }
			    else{
			    	PageName="home page"
			    }
			};
			CT.utils.trackers.eventData = {};
			CT.utils.trackers.eventData.searchedString = "";
			CT.utils.trackers.eventData.userSessionStart = Date.now();
			CT.utils.trackers.clevertapGlobleData={
				"platform":"Desktop",
				"destinationCity":"N/A",
				"destinationCountry":"N/A",
				"marketNature":"N/A",
				"dx":"N/A",
				"rooms":"N/A",
				"los":"N/A",
				"DayOfWeek_checkIn":"N/A",
				"pax":"N/A",
				"numAdults":"N/A",
				"numChild":"N/A",
				"childAge":"N/A",
				"roomNights":"N/A",
				"userSignedInStatus":CT.utils.readCTAuthCookie()?"Yes":"No"
			};
			
			// CT.utils.trackers.mixpanelTrackingData={
			// 	"cookieId":CT.utils.cookies.read('Apache') ? CT.utils.cookies.read('Apache') :"N/A",
			// 	"ipAddress":"N/A",
			// 	"visitortype":"N/A",
			// 	"utmz":CT.utils.cookies.read('__utmz') ? CT.utils.cookies.read('__utmz') : "N/A",
			// 	"devicetype":"Desktop",
			// 	"referralSource":document.referrer||"N/A",
			// 	"currencySelected":CT.settings.countryCurrCode[window.countryCode].code,
			// 	"countrySelected":window.countryCode.toUpperCase(),
			// 	"emailID":(decodeURIComponent(CT.utils.cookies.read('userid')).split("|")[0])!="null"?(decodeURIComponent(CT.utils.cookies.read('userid')).split("|")[0]):"N/A",
			// 	"currentDate":(new Date()).toDateString(),
			// 	"hotelID":"N/A",
			// 	"hotelName":"N/A",
			// 	"starRating":"N/A",
			// 	"taRating":"N/A",
			// 	"destinationCity":"N/A",
			// 	"checkInDate":"N/A",
			// 	"checkOutDate":"N/A",
			// 	"numRooms":"N/A",
			// 	"numAdults":"N/A",
			// 	"numChildren":"N/A",
			// 	"itineraryID":"N/A",
			// 	"itineraryReferrer":"N/A",
			// 	"tripID":"N/A",
			// 	"paymentType":"N/A",
			// 	"srpReferrer":"N/A",
			// 	"domain"     :window.location.hostname,
			// 	"marketNature":"N/A",
			// 	"PAH":'N/A',
			// 	'PAHCC':'N/A',
			// 	"los":'N/A',
			// 	"dx":"N/A",
			// 	"paxCount":'N/A',
			// 	"roomNights":'N/A',
			// 	"abTestCookie":String(CT.utils.cookies.read("ct-ab")),
			// 	"userLogin_status":CT.utils.readCTAuthCookie()?"Yes":"No",
			// 	"DoTD_Hotel":"N/A",
			// 	"searchType": "N/A",
			// 	"entryPoint":"N/A",
			// 	"hotel360Images":"N/A"
			// };
			CT.utils.trackers.ctanalyticsTrackingData('Hotels_TS','Page_Viewed','Home_Page_Loaded',{},'page_load');
			var mostRecentSearchData = Store("Recents").get('lastFormSearch');
		  	CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Home_view",{
		  		"autofillCity": mostRecentSearchData ? mostRecentSearchData.city : "N/A",
		  		"autofillCheckinDate": mostRecentSearchData ? mostRecentSearchData.chk_in : "N/A",
		  		"autofillCheckoutDate": mostRecentSearchData ? mostRecentSearchData.chk_out : "N/A"
			});
			var hotelSearchTravellerInfoAB = CT.utils.getAbTestCookie('hotelSearchTravellerInfoAB');
			if(hotelSearchTravellerInfoAB === "b"){
				$("#travellersOnhome").val(1).trigger("change");
			} 
		},

		updateTabIndices : function(){
			var tabIndex = 0
			this.$('input, select').not('[type="hidden"], :hidden').map(function(){ $(this).attr('tabindex', ++tabIndex) })
			return this
		},


		preFillTravellerInfo : function(searchData) {
			var numOfRooms= searchData['num_rooms'];
			var numOfChild=searchData['childs'];

			var numOfAdults=searchData['adults'];
			$("#travellersOnhome").find("option").removeAttr("selected");
			// if($(".travellers").attr("data-added")=="afterSearch")
			$("#travellersOnhome [data-added='afterSearch']").remove();
			if(numOfAdults==2 && numOfRooms==1 && numOfChild==0)
				$('#travellersOnhome option[value="2"]').attr("selected","true");
			else if(numOfAdults==4 && numOfRooms==2 && numOfChild==0)
				$('#travellersOnhome option[value="4"]').attr("selected","true");
			else if(numOfAdults==1 && numOfRooms==1 && numOfChild==0)
				$('#travellersOnhome option[value="1"]').attr("selected","true");
			else{
				if(searchData['childs']!=0 || numOfAdults>=3 || numOfRooms>2){
					var spanString=numOfRooms+(numOfRooms==1?" room,":" rooms,")+" "+numOfAdults+(numOfAdults==1?" adult":" adults")+(numOfChild!=0?", "+numOfChild+(numOfChild==1?" child":" children"):"");
					if(spanString.replace(/\s+/g, '')!==$("#travellersOnhome").find("option").attr("data-value"))
						$("#travellersOnhome:first-child").prepend("<option selected=true data-added=afterSearch data-value="+spanString.replace(/\s+/g, '')+" value="+numOfRooms+","+numOfAdults+","+numOfChild+">"+spanString+"</option>");
				}
			}
			$("#travellersOnhome").trigger("change");
			if(numOfRooms !=1){
				this.$el.find(".selectRoom").val(numOfRooms).trigger("change");
			}
			for(var i=1;i<=numOfRooms;i++){
				this.$el.find("#Adult_"+i).val(searchData["adults"+i]).trigger("change");
				this.$el.find("#Childs_"+i).val(searchData["children"+i]).trigger("change");
				for(var j=0;j<Number(searchData["children" +i]);j++){
					$(this.$el.find("#Age_"+i).find("select")[j]).val(searchData["ca"+i][j]);
				}
			}
			

		},
		preFillHotelId : function(searchData) {
			if(searchData.hotelId && searchData.hotelId != ""){
				this.$el.find("#HotelId").val(searchData.hotelId);
			}else{
				this.$el.find("#HotelId").val("");
			}
		},

		preFillCheckInDate : function(searchData) {
			var ci = searchData['chk_in'];
			if(moment(ci, "DD/MM/YYYY").add('seconds',86399) >= moment()){
				var ci = searchData['chk_in'];
				this.$el.find("#FromDate").val(moment(ci, "DD/MM/YYYY").format("DD/MM/YYYY"));
				$.datepicker._setDateDatepicker($("#CheckInDate").get(0), moment(ci, "DD/MM/YYYY").format('ddd, DD MMM, YYYY'));
			}else{
				searchData['chk_in'] = "";
				var ci = searchData['chk_in'];
				this.$el.find("#FromDate").val("");
			}
		},

		preFillCheckOutDate : function(searchData) {
			var co = searchData['chk_out'];
			var checkInPlusOneDay = moment(searchData['chk_in'], "DD/MM/YYYY").add('d', 1).format("ddd, DD MMM, YYYY");
			if(moment(co, "DD/MM/YYYY").add('seconds',86399) >= moment()){
				this.$el.find("#ToDate").val(moment(co, "DD/MM/YYYY").format("DD/MM/YYYY"));
				this.$el.find("#CheckOutDate").parents("dl").removeClass("faded");
				$.datepicker._setDateDatepicker($("#CheckOutDate").get(0), moment(co, "DD/MM/YYYY").format('ddd, DD MMM, YYYY'));
				this.$el.find("#CheckOutDate").datepicker("option", "minDate", checkInPlusOneDay);
			}else{
				searchData['chk_out'] = "";
				var ci = searchData['chk_out']
				this.$el.find("#ToDate").val("");
			}
		},

		preFillDestCode: function() {},

		renderSearchForm : function(persObj,lastSearchObj) {
			var thisForm = this,
			mostRecentSearchData, frm_mapper,
			$searchForm = this.$el,
			frmValue, tmp;
			var currentTime = new Date().getTime();
			var fieldToRemember = ['from', 'city', 'state', 'country', 'area', 'poi', 'hotelName', 'dest_code'];
			// this.travellersOnChange();
			// $("#travellersOnhome").trigger("change");
			/*if(CT.utils.cookies.read('hotelTripType') != null){
				if($(".tripType").length > 0){
					var $ele = $("#"+CT.utils.cookies.read('hotelTripType'));
					$ele.attr("checked","checked").trigger("click");
				}else{
					this.updateWgParams(undefined,"withinCity")
				}
			}else if($("#withinCity").length > 0){
				var $ele = $("#withinCity");
				$ele.attr("checked","checked").trigger("click");
			}else{
				this.updateWgParams(undefined,"withinCity")
			}*/
			this.updateWgParams(undefined,"withinCity")
			/*if($("body").hasClass("home") == true){
				if($(".tripType").length > 0){
			  		this.updateWgParams(undefined,$("input[name='trip_type']:checked").val())
			  	}else{
			  		this.updateWgParams(undefined,"withinCity")
			  	}
			  }*/

			  if(lastSearchObj){
			  	var mostRecentSearchData = lastSearchObj;
			  }else{
			  	var mostRecentSearchData = Store("Recents").get('lastFormSearch');
			  }
			  if(typeof mostRecentSearchData === "undefined") {
			  	return false;
			  }

			  if(!_.isUndefined(mostRecentSearchData) && mostRecentSearchData.length >0 ) {
			  	mostRecentSearchData =  _.first(mostRecentSearchData);
			  }

			  if( (mostRecentSearchData.sd && currentTime - mostRecentSearchData.sd) > (1000 * 60 * 60)) {
			  	_.each(fieldToRemember, function(field) {
			  		$searchForm.get(0)[field].value = mostRecentSearchData[field];
			  	});
			  	if(mostRecentSearchData.area && mostRecentSearchData.area[0]!=""){
			  		mostRecentSearchData.poi[0]=mostRecentSearchData.area[0]
			  		mostRecentSearchData.area[0]=""
			  	}
			  	return false;
			  }

			// Temporarily checking if the site is arabic then it should not pre fill the checkIn/checkOut dates
			if (_.deserialize(window.location.search.substring(1)).l == "ar" || CT.utils.cookies.read("lp") == "ar") {
				mostRecentSearchData['chk_in'] = ''; mostRecentSearchData['chk_out'] = '';
			}
			else{
				_(mostRecentSearchData).map(function(value, key) {
					if(key === "chk_in" && new Date(CT.utils.swapDayMonth(value)) < new Date(moment().format("MM/DD/YYYY")) ) {
						mostRecentSearchData['chk_in'] = ''; mostRecentSearchData['chk_out'] = '';
					}
				});
			}

			if(mostRecentSearchData) {
				frm_mapper = {
					'Tags' : 'from',
					'wgSelectChoosen' : 'from',
					'CheckInDate' : 'chk_in',
					'CheckOutDate' : 'chk_out',
					'DestCode' : 'dest_code',
					'City' : 'city',
					'State' : 'state',
					'Country' : 'country',
					'Area' : 'area',
					'Poi' : 'poi',
					'City' : 'city',
					'HotelId' : 'hotelId',
					'HotelName' : 'hotelName',
					'noOfTraveller' : 'num_rooms'
				}

		  		//logic for fill data in search tag field
		  		_.each(_.keys(frm_mapper), function(frmId, idx) {
		  			if(thisForm.$el.find("#"+frmId)) {

		  				if(frmId == 'Area' || frmId == 'Poi')
		  					frmValue = mostRecentSearchData[frm_mapper[frmId]] ? mostRecentSearchData[frm_mapper[frmId]][0] : '';
		  				else
		  					frmValue = mostRecentSearchData[frm_mapper[frmId]];

		  				tmp = '';
		  				if(frmId == 'Tags') {
							// it can be a area search or poi search or hotel search or none of these
							if(mostRecentSearchData.area && (tmp = mostRecentSearchData.area[0]) != '') {
								CT.utils.trackers.eventData.categorySelected = "Area";
							}
							else if(mostRecentSearchData.poi && (tmp = mostRecentSearchData.poi[0]) != '') {
								CT.utils.trackers.eventData.categorySelected = "POI";
							}
							else if(mostRecentSearchData.hotelName && (tmp = mostRecentSearchData.hotelName) != '') {
								CT.utils.trackers.eventData.categorySelected = "Hotel";
							} else {
								CT.utils.trackers.eventData.categorySelected = "City";
							}

							//if tmp not undefined and not empty
							if(tmp && tmp != '')
								frmValue = _.titleize(tmp) + ', ' + frmValue;
						}

			        	if(frmValue && _.isDate(frmValue)) { //check for checkin and checkout date
			        		if(!$(document.activeElement).is("#"+frmId))
			        			thisForm['preFill'+frmId](mostRecentSearchData);
			         	} else if(frmId === 'noOfTraveller') { //room and pax information
			         		thisForm.preFillTravellerInfo(mostRecentSearchData);
			         	} else if(frmId === 'wgSelectChoosen' && (mostRecentSearchData.wg == true || CT.settings[CT.app].weekendDestinations.indexOf(frmValue) != -1)){
			         		if(!$('.chzn-select').find('option[value="' + frmValue + '"]').length){
			         			$('.chzn-select #SelectedCities').append(new Option(frmValue, frmValue));

			         		}	
			         		thisForm.$el.find("#"+frmId).val(frmValue)
			         		$('.chzn-select').trigger("chosen:updated");
			            } else { //other search field
			            	if(!$(document.activeElement).is("#"+frmId)){
			            		if(frmId === 'Tags' && mostRecentSearchData.wg == undefined){
			            			thisForm.$el.find("#"+frmId).val(frmValue);
			            			thisForm.$el.find("#"+frmId).attr({"category":"recentSearch","locationSelected":frmValue})
			            		}else if(frmId === 'Tags' && mostRecentSearchData.wg != undefined){
			            			thisForm.$el.find("#"+frmId).val(frmValue);
			            		}else if(frmId === 'wgSelectChoosen' && mostRecentSearchData.wg == undefined){
			            			
			            		}else{
			            			thisForm.$el.find("#"+frmId).val(frmValue);
			            		}
			            	}
			            }

			        }
			    });
				if(mostRecentSearchData.chk_in != "" &&  mostRecentSearchData.chk_out != ""){
					var duration = _.datesDuration(moment($("#FromDate").val(),"DD/MM/YYYY").format("MM/DD/YYYY"), moment($("#ToDate").val(),"DD/MM/YYYY").format("MM/DD/YYYY"));
					CT.lengthOfStay=duration;
					$("#HotelDuration").parents(".indicator").html('<span id="HotelDuration">'+ duration + ' night' +(duration >1 ?'s' : '')+'</span>');
				}
				var isEnableHotelsBackgroundSearch = window.enableHotelsBackgroundSearch && (!window.isResultsPage || (window.isResultsPage && CT.cache[CT.settings.currentTab].isSRPLoaded));
				if(isEnableHotelsBackgroundSearch){
					hotelBackgroundSearch.getHotelContent({city:mostRecentSearchData.city, state:mostRecentSearchData.state, country:mostRecentSearchData.country});
					hotelBackgroundSearch.getCityImages({city:mostRecentSearchData.city, state:mostRecentSearchData.state, country:mostRecentSearchData.country});
				}
			}
		  	//console.log("Load of search form")
		  },
		  travellersOnChange: function(evt) {
		  	// $("#travellersOnhome").bind('change',function(evt) {
		  		if (evt.target.value == "2") {
		  			$("#Adult_1").val(2);
		  			$("#Adult_1.alterAdult").trigger("change");
		  			$(".selectRoom").val(1).trigger("change");
		  			$(".alterChild").val(0).trigger("change");
		  		} else if (evt.target.value == "4") {
		  			$(".selectRoom").val(2).trigger("change");
		  			$("#Adult_1").val(2);
		  			$("#Adult_2").val(2);
		  			$("#Adult_1.alterAdult").trigger("change");
		  			$("#Adult_2.alterAdult").trigger("change");
		  			$(".alterChild").val(0).trigger("change");
		  		} else if (evt.target.value == "1") {
		  			$("#NoOfRoom").val(1);
		  			$(".selectRoom").val(1).trigger("change");
		  			$("#Adult_1").val(1);
		  			$("#Adult_1.alterAdult").trigger("change");
		  			$(".alterChild").val(0).trigger("change");
		  		}
		  		if (evt.target.value == "MoreTravellers") {
		  			$(".roomWidget").fadeIn();
		  		} 
		  		else {
		  			$(".roomWidget").fadeOut();
		  		}
				
		  	// });
		  },
formSubmitSuccessCallBack:function(){
	function paxCount(){
		var paxCnt = 0;
		for(var i=0;i<parseInt($('.selectRoom').val());i++){
			paxCnt = parseInt(paxCnt) + parseInt($('#Adult_'+(i+1)).val())

		}
		for(var i=0;i<parseInt($('.selectRoom').val());i++){
			paxCnt = parseInt(paxCnt) + parseInt($('#Childs_'+(i+1)).val())

		}
		return paxCnt;
	}

	if(CT.utils.getAbTestCookie('hotel2Col') == 'b'){
		CT.utils.addHiddenField($('#SearchForm'), "hotel2Col", "true");
	}else{
		$("input[name='hotel2Col']").remove();
	}

			//console.log("Onclick of search")
			var params = _.deserialize(this.$el.serialize()),diffDate="",LOS="";
			if(params.area!=""){
				params.poi=params.area
				params.area=""
			}
			var adultCount = "0";
			var childCount = "0";
			var paxTotalCount = "";	
			if(params.num_rooms){
				for(i=1;i<=parseInt(params.num_rooms);i++){
					if(params['adults'+[i]]){
						adultCount = parseInt(adultCount) + parseInt(params['adults'+[i]]);
					}
					if(params['children'+[i]]){
						childCount = parseInt(childCount) + parseInt(params['children'+[i]]);
					}
				}
				paxTotalCount = parseInt(adultCount) + parseInt(childCount);
			}
			var los = (params.chk_in && params.chk_in != "" && params.chk_out && params.chk_out != "" && CT.utils && CT.utils.diffDates) ? CT.utils.diffDates(params.chk_in, params.chk_out) : "N/A";
			if(typeof(CT.utils.helperFunctions.trackGAEvent) === "function" && params.chk_in !="" && params.chk_out != ""){
				var chkinDate = moment(params.chk_in,"DD/MM/YYYY")
				var todaysDate =moment();
				var diffDate = chkinDate.diff(todaysDate,'days');
				var chkOutDate = moment(params.chk_out , "DD/MM/YYYY")
				var LOS = chkOutDate.diff(chkinDate,'days');
			}
			if(CT.subProd == undefined){
				var url = "city="+params.city+"&country="+params.country+"&num_rooms="+params.num_rooms+"&D+X="+diffDate+"&LOS="+LOS

			}else{
				var url = "from="+params.city+"&country="+params.country+"&num_rooms="+params.num_rooms+"&D+X="+diffDate+"&LOS="+LOS

			}
			
			if(paxCount() > 4){
				CT.utils.helperFunctions.inspectLetJsForHotels();
			}
			
			var category = "Hotels_TS", action = "H_Search_Button";
			if($("body").is(".srp")){
				category = "Hotels_TR"
				action = "H_Modify_Search";
				url = CT.cache[CT.settings.currentTab].paramsForGA;
			}
			CT.utils.helperFunctions.trackGAEventWrapper(category, action, url, '100');
			var moengageTrackingData = {
	        	"d"   : params.city ? params.city : "N/A",
				"ci"  : params.chk_in ? params.chk_in : "N/A",
				"co"  : params.chk_out ? params.chk_out : "N/A",
				"dx"  : (params.chk_in && params.chk_in != "" && window.ctCurrentDate && CT.utils && CT.utils.diffDates) ? CT.utils.diffDates(window.ctCurrentDate, params.chk_in) : "N/A",
				"los" : los,
				"st"  : (params.chk_in != "" && params.chk_out != "") ? "wd" : "dl",
				"rc"  : params.num_rooms ? params.num_rooms : "N/A",
				"rn"  : (params.num_rooms && los && los != "N/A") ? parseInt(los) * parseInt(params.num_rooms) : "N/A",
				"pc"  : paxTotalCount,
				"ac"  : adultCount,
				"cc"  : childCount,
				"dl"  : ""
	        }
	        if(window.moengageEnabled){
	        	CT.utils.helperFunctions.tpTrack({'tp':'moengage','category':'hsc','values':moengageTrackingData});
			}
			window.scrollTo(0,0);
		}
	}));
	// This is the search form View object, NOT settings
	return searchFormView;
}, CT.cache.views);

